import $ from "jquery";
import objectFitImages from "object-fit-images";
import svg4everybody from "svg4everybody";
import stickybits from "stickybits";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "picturefill";
import "responsive-bp";
import "slick-carousel";
import "@fancyapps/fancybox";

import uiHelpers from "./uiHelpers";
import MenuItem from "./components/MenuItem";

import "./components/Autocomplete";
import Accordion from "./components/Accordion";
import compositeFields from "./components/CompositeFields";
import Conversation from "./components/Conversation";
import eitherFields from "./components/EitherFields";
import maxCharacterCounts from "./components/MaxCharacterCount";
import selfHelpVisibility from "./components/SelfHelpVisibility";
import Tabs from "./components/Tabs";
import Tooltip from "./components/Tooltip";
import "./components/RepeatableFields";
import "./components/SearchBar";
import "./components/SearchBarTerritory";
import "./components/Typeahead";
import "./components/Feedback";
import "./components/RangeSlider";
import "./components/Poll";
import "./components/LandingPage";
import "./components/Calendar";
import "./components/Form";

svg4everybody();
uiHelpers.init();
objectFitImages();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Sticky header
stickybits(".js-sticky-header", {
  stickyChangeClass: "is-sticky-change",
  stickyClass: "is-sticky",
  stuckClass: "is-stuck",
  useStickyClasses: true,
});

let headerHeight = $(".primary-header").outerHeight();

if ($("#alert-message").length) {
  const alertHeight = $("#alert-message").outerHeight();
  headerHeight = headerHeight + alertHeight;
}

// Navigation
$(".js-nav-toggle").on("click", (e) => {
  const $toggle = $(e.currentTarget);
  const targetId = $(e.currentTarget).attr("aria-controls");
  const $target = $(`#${targetId}`);

  // Set scroll pos to 0 if scrollY is within secondary nav
  if (window.scrollY < 30) {
    window.scrollTo(0, 0);
  }

  if (!$target.hasClass("is-active")) {
    $toggle.addClass("is-active");
    $target.addClass("is-active").focus();
    $("body").addClass("has-nav-open");
  } else {
    $toggle.removeClass("is-active");
    $target.removeClass("is-active");
    $("body").removeClass("has-nav-open");
  }
});

$(".js-nav-item").each((index, element) => {
  new MenuItem(element);
});

$(".js-nav-close").on("click", (e) => {
  $(".js-nav-toggle").attr("aria-expanded", false).removeClass("is-active");
  $("#navigation").removeClass("is-active");
  $("body").removeClass("has-nav-open");
});

// Hero portal links
$(".js-portal-toggle").on("click", (e) => {
  const $toggle = $(e.currentTarget);
  $toggle.next(".js-portal-links").slideToggle();
});

// Accordions
const accordions = document.querySelectorAll(".js-accordion");
accordions.forEach((element) => new Accordion(element as HTMLElement));

// Conversations
new Conversation();

// Tooltips
const tooltips = document.querySelectorAll(".tooltip");
tooltips.forEach((element) => new Tooltip(element as HTMLElement));

// Slick
$(".js-carousel").slick({
  arrows: true,
  responsive: [
    {
      breakpoint: 980,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: "80px",
        slidesToShow: 1,
      },
    },
  ],
  slidesToShow: 3,
});

$(".js-carousel-panel").slick({
  arrows: true,
  slidesToShow: 1,
});

// Tabbed content
const tabpanels = document.querySelectorAll(".js-tabs");
tabpanels.forEach((tabpanel) => new Tabs(tabpanel as HTMLElement));

// Scroll
const isLandingPage = document.querySelector(".landing-page") as HTMLElement;

function attachToPanel(percentageOfViewport) {
  const panelNodeList = document.querySelectorAll(".panel"); // returns NodeList

  for (const panel of panelNodeList as any) {
    if (panel.getBoundingClientRect().top <= percentageOfViewport) {
      panel.classList.add("panel--in-view");
    }
  }
}

// Search checkbox tabs
$(".js-search-checkbox").change((e) => {
  e.preventDefault();

  const searchCheckbox = e.currentTarget;
  if (searchCheckbox.checked) {
    $(".js-search-checkbox").prop("checked", false);
    searchCheckbox.checked = true;
    // Submit form
    $(searchCheckbox).parents("form").submit();
  } else {
    searchCheckbox.checked = true;
  }
});

if (isLandingPage) {
  let ticking = false;
  let percentageOfViewport = window.innerHeight * 0.8;

  attachToPanel(percentageOfViewport);

  document.addEventListener("resize", () => {
    percentageOfViewport = window.innerHeight * 0.8;
  });

  document.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        attachToPanel(percentageOfViewport);
        ticking = false;
      });

      ticking = true;
    }
  });
}

maxCharacterCounts();

// Validate composite hidden fields - unless they're hidden by Umbraco Forms conditional logic
$.validator.setDefaults({
  ignore:
    ":hidden:not(.must-validate), .umbraco-forms-field[style*='display: none'] .must-validate, .umbraco-forms-fieldset[style*='display: none'] .must-validate",
});

selfHelpVisibility();
compositeFields();
eitherFields();
